module.exports = __webpack_public_path__ + "img/5.f6bfc56e.png";